<template>
  <section class="content close-date-picker">
    <!-- <div v-if="loading" class="content content-centered">
        <pulse-loader></pulse-loader>
      </div> -->
    <div class="main_select_wrp_relative">
      <div class="modal fade model_modify_wrp" id="exportCSV" tabindex="-1" role="dialog"
        aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div class="modal-dialog" role="document" style="width: 50%">
          <div class="modal-content">
            <div class="modal-header">
              <h2>Export </h2>
              <button type="button" class="close clearButton" data-dismiss="modal" v-on:click="clearFilterCSV()">Clear
                All</button>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="col-sm-12" style="padding-bottom: 20px;">
              <div class="modal-body">
                <div class="col-sm-6">
                  <label>Start Date</label>
                  <date-picker id="startDate" v-model="dateCSV.startDateCSV" @change="startDateCSV()" lang="en"
                    name="startDate" required input-class="form-control" width="100%" valueType="format"
                    :format="'DD-MM-YYYY'" placeholder="Start date">
                  </date-picker>
                </div>
                <div class="col-sm-6">
                  <label>End Date</label>
                  <date-picker id="endDate" lang="en" name="endDate" required v-model="dateCSV.endDateCSV"
                    input-class="form-control" width="100%" valueType="format" :not-before="startDateIsoCSV"
                    :format="'DD-MM-YYYY'" placeholder="End date" @change="endDateCSV()">
                  </date-picker>
                </div>
              </div>
            </div>
            <div class="col-sm-12 text-right export_CSV">

              <button class="mr-2 btn gradientbt " type="submit" @click="exportCSV">
                Export
              </button>

            </div>

          </div>

        </div>
      </div>
      <div class="modal fade model_modify_wrp" id="filtertoogle" tabindex="-1" role="dialog"
        aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div class="modal-dialog" role="document" style="width: 50%">
          <div class="modal-content">
            <div class="modal-header">
              <h2>Filters</h2>
              <button type="button" class="close clearButton" data-dismiss="modal" v-on:click="clearFilter()">Clear
                All</button>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <label>Start Date</label>
              <date-picker id="startDate" v-model="date.startDate" @change="startDate()" lang="en" name="startDate"
                required input-class="form-control" width="100%" valueType="format" :format="'DD-MM-YYYY'"
                placeholder="Start date">
              </date-picker>
              <label>End Date</label>
              <date-picker id="endDate" lang="en" name="endDate" required v-model="date.endDate"
                input-class="form-control" width="100%" valueType="format" :not-before="startDateIso"
                :format="'DD-MM-YYYY'" placeholder="End date" @change="endDate()">
              </date-picker>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="box box-primary">
      <div class="box-body">

        <div class="filter_wrpp filtered">
          <div class="sorting2">
            <div class="col-md-8">
              <select class="form-control" @change="fiteredResultGA" v-model="regionValue">
                <option value="all">All GA</option>
                <option v-for="(item, index) in journey_managers" :key="index" :value="item.key">
                  {{ item.value }}
                </option>
              </select>
            </div>
            <div class="col-md-4">
              <button class="btn inline" @click="clearStatusGA">Clear</button>
            </div>
          </div>

          <div class="applyFilter" style="display: flex;">
            <!-- <div class="exportCSVbtn">
              <button type="button" class="btn gradientbt" data-toggle="modal" data-target="#exportCSV">
                Export
              </button>
            </div> -->

            <button type="button" class="btn gradientbt" data-toggle="modal" data-target="#filtertoogle">
              <svg xmlns="http://www.w3.org/2000/svg" xmlns:cc="http://creativecommons.org/ns#"
                xmlns:dc="http://purl.org/dc/elements/1.1/" xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#">
                <g transform="translate(0 -1028.4)">
                  <path d="m10 11v10l4 3v-13h-4z" fill="#fff" transform="translate(0 1028.4)" />
                  <path d="m10 11v10l2 1.5v-11.5h-2z" fill="#fff" transform="translate(0 1028.4)" />
                  <path d="m1 1028.4 9 11h4l9-11z" fill="#fff" />
                  <path d="m1 1028.4 9 11h2v-11z" fill="#fff" />
                </g>
              </svg>
              Apply Filter
            </button>
          </div>
        </div>
        <ul class="nav nav-tabs">
          <li :class="driverActive">
            <a data-toggle="tab" @click.prevent="showDriver()">Driver</a>
          </li>
          <li :class="vehicleActive">
            <a data-toggle="tab" @click.prevent="showVehicle()">Vehicle</a>
          </li>
        </ul>

        <!-- Driver Table -->
        <div v-show="showDriverTable" class="tab-pane fade in" :class="driverActive">
          <div class="filter"></div>
          <v-server-table ref="driverTable" url :limit="5" :columns="column" :options="option" @loaded="onLoaded">
            <template slot="beforeBody">
              <tr v-if="loading" class="VueTables__no-results">
                <td class="text-center" colspan="9">
                  <pulse-loader></pulse-loader>
                </td>
              </tr>
            </template>
            <template slot="licenseExpiryDate" slot-scope="props">
              <div :class="getDateClass(props.row.licenseExpiryDate)">
                {{ props.row.licenseExpiryDate ? dateFormatters(props.row.licenseExpiryDate) : 'NA' }}
              </div>
            </template>
            <template slot="ddtExpiryDate" slot-scope="props">
              <div :class="getDateClass(props.row.ddtExpiryDate)">
                {{ props.row.ddtExpiryDate ? dateFormatters(props.row.ddtExpiryDate) : 'NA' }}
              </div>
            </template>
            <template slot="hazExpiryDate" slot-scope="props">
              <div :class="getDateClass(props.row.hazExpiryDate)">
                {{ props.row.hazExpiryDate ? dateFormatters(props.row.hazExpiryDate) : 'NA' }}
              </div>
            </template>

          </v-server-table>
        </div>

        <!-- Vehicle table -->
        <div v-show="showVehicleTable" class="tab-pane fade in" :class="vehicleActive">
          <div :class="addButtonClass"></div>
          <v-server-table ref="vehilceTable" url :limit="5" :columns="columns" :options="options" @loaded="onLoad">
            <template slot="beforeBody">
              <tr v-if="loadings" class="VueTables__no-results">
                <td class="text-center" colspan="9">
                  <pulse-loader></pulse-loader>
                </td>
              </tr>

            </template>
            <template slot="rcValidity" slot-scope="props">
              <div :class="getDateClass(props.row.rcValidity)">
                {{ props.row.rcValidity ? dateFormatters(props.row.rcValidity) : 'NA' }}
              </div>
            </template>
            <template slot="insuranceValidity" slot-scope="props">
              <div :class="getDateClass(props.row.insuranceValidity)">
                {{ props.row.insuranceValidity ? dateFormatters(props.row.insuranceValidity) : 'NA' }}
              </div>
            </template>
            <template slot="pucValidity" slot-scope="props">
              <div :class="getDateClass(props.row.pucValidity)">
                {{ props.row.pucValidity ? dateFormatters(props.row.pucValidity) : 'NA' }}
              </div>
            </template>
            <template slot="fitCertValidity" slot-scope="props">
              <div :class="getDateClass(props.row.fitCertValidity)">
                {{ props.row.fitCertValidity ? dateFormatters(props.row.fitCertValidity) : 'NA' }}
              </div>
            </template>
            <template slot="gcpValidity" slot-scope="props">
              <div :class="getDateClass(props.row.gcpValidity)">
                {{ props.row.gcpValidity ? dateFormatters(props.row.gcpValidity) : 'NA' }}
              </div>
            </template>
          </v-server-table>
        </div>

      </div>
    </div>
  </section>
</template>
<script>
import axios from 'axios';
import Config from '../../../config';
import { mapState } from 'vuex';
import moment from 'moment';
import { USER_ROLES } from '../../../config';
export default {
  name: 'complianceReport',
  data() {
    return {
      regionValue: 'all',
      journey_managers: [],
      dateCSV: {
        startDateCSV: "",
        endDateCSV: "",
      },
      startDateIsoCSV: "",
      endDateIsoCSV: "",
      selectedTab: 'Driver',
      loading: '',
      loadings: '',
      showDriverTable: true,
      showVehicleTable: false,
      driverActive: "",
      vehicleActive: "",
      driverTable: null,
      vehilceTable: null,
      USER_ROLES: USER_ROLES,
      date: {
        startDate: "",
        endDate: "",
      },
      startDateIso: "",
      endDateIso: "",
      params: {},
      parameters: {},
      exportName: "",
      regionManagersIdList: [],
      parameterss: '',


      //driverTable

      column: ['driverName', 'mobileNumber', 'lisenceNumber', 'licenseExpiryDate', 'ddtExpiryDate', 'hazExpiryDate', 'regionName', 'status'],
      option: {
        highlightMatches: true,
        headings: {
          driverName: 'Driver Name',
          mobileNumber: 'Contact Number',
          lisenceNumber: 'License Number',
          licenseExpiryDate: 'License Expiry Date',
          ddtExpiryDate: 'DDT Expiry Date',
          hazExpiryDate: 'HAZCAM Expiry Date',
          regionName: 'GA Name',
          status: 'Status'
        },
        perPage: 10,
        sortable: ['driverName', 'mobileNumber', 'lisenceNumber', 'licenseExpiryDate', 'ddtExpiryDate', 'hazExpiryDate', 'regionName', 'status'],
        templates: {
          licenseExpiryDate(row, query) {
            return `${moment(`${query.licenseExpiryDate}`).format('DD-MM-YYYY')}`;
          },
          ddtExpiryDate(row, query) {
            return `${moment(`${query.ddtExpiryDate}`).format('DD-MM-YYYY')}`;
          },
          hazExpiryDate(row, query) {
            return `${moment(`${query.hazExpiryDate}`).format('DD-MM-YYYY')}`;
          },
          status(row, query) {
            return query.status[0].toUpperCase() + query.status.slice(1);
          },
        },
        requestFunction: request => {
          this.params.page = request.page;
          this.params.limit = request.limit;
          if (request.orderBy) {
            this.params.sortBy = request.orderBy;
            if (request.ascending == 1) {
              this.params.sortOrder = "asc";
            } else {
              this.params.sortOrder = "des";
            }
          }
          if (request.query !== '') {
            this.params.searchString = request.query;
          } else {
            this.params.searchString = '';
          }
          if (this.parameterss != '') {
            this.params.region = this.parameterss;
          } else if (this.regionManagersIdList.length !== 0) {
            this.params.region = this.regionManagersIdList;
          }
          this.loading = true;
          return this.$driverComplianceDataRepository.list(this.params).catch(error => {
            console.error('driverCompliance.requestFunction-error:', error);
          });
        },
        responseAdapter: response => {
          this.loading = false;
          return {
            data: response.data.driverData,
            count: response.data.driversCount,
          };
        }
      },

      // vehicleTable

      columns: ['regNo', 'transportSupervisorName', 'rcValidity', 'insuranceValidity', 'pucValidity', 'fitCertValidity', 'gcpValidity'],
      options: {
        highlightMatches: true,
        headings: {
          regNo: 'Registration Number',
          transportSupervisorName: 'Transporter Name',
          rcValidity: 'RC Validity',
          insuranceValidity: 'Insurance Validity',
          pucValidity: 'PUC Validity',
          fitCertValidity: 'Fitness Validity',
          gcpValidity: 'Goods Carriage Permit Validity'
        },
        perPage: 10,
        sortable: ['regNo', 'transportSupervisorName', 'rcValidity', 'insuranceValidity', 'pucValidity', 'fitCertValidity', 'gcpValidity'],
        templates: {
          rcValidity(row, query) {
            return `${moment(`${query.rcValidity}`).format('DD-MM-YYYY')}`;
          },
          insuranceValidity(row, query) {
            return `${moment(`${query.insuranceValidity}`).format('DD-MM-YYYY')}`;
          },
          pucValidity(row, query) {
            return `${moment(`${query.pucValidity}`).format('DD-MM-YYYY')}`;
          },
          fitCertValidity(row, query) {
            return `${moment(`${query.fitCertValidity}`).format('DD-MM-YYYY')}`;
          },
          gcpValidity(row, query) {
            return `${moment(`${query.gcpValidity}`).format('DD-MM-YYYY')}`;
          },
        },
        requestFunction: request => {
          // const params = {};
          this.parameters.page = request.page;
          this.parameters.limit = request.limit;
          if (request.orderBy) {
            this.parameters.sortBy = request.orderBy;
            if (request.ascending == 1) {
              this.parameters.sortOrder = "asc";
            } else {
              this.parameters.sortOrder = "des";
            }
          }
          if (request.query) {
            this.parameters.searchString = request.query;
          } else {
            this.params.searchString = '';
          }
          if (this.parameterss != '') {
            this.parameters.region = this.parameterss;
          } else if (this.regionManagersIdList.length !== 0) {
            this.parameters.region = this.regionManagersIdList;
          }
          this.loadings = true;
          return this.$vehicleComplianceDataRepository.list(this.parameters).catch(error => {
            console.error('vehicleCompliance.requestFunction-error:', error);
          });
        },
        responseAdapter: response => {
          this.loadings = false;
          return {
            data: response.data.vehicleData,
            count: response.data.vehiclesCount,
          };
        }
      }

    }
  },
  mounted: function () {
    this.getGeographicalAreas();
  },
  computed: {
    addButtonClass() {
      if (this.driverTable) {
        return this.driverTable.count > this.driverTable.limit ||
          this.driverTable.limit > 10
          ? 'shift-add-left'
          : 'add-item';
      } else {
        return 'add-item';
      }
    },
    ...mapState({
      user: state => state.auth.user,

    }),
  },
  methods: {

    clearFilterCSV() {
      this.dateCSV.startDateCSV = '';
      this.dateCSV.endDateCSV = '';
    },
    startDateCSV() {
      const eventDataCSV = this.dateCSV.startDateCSV.split("-");
      this.startDateIsoCSV = eventDataCSV[2] + "-" + eventDataCSV[1] + "-" + eventDataCSV[0];
    },
    endDateCSV() {
      const eventDataCSV = this.dateCSV.endDateCSV.split("-");
      this.endDateIsoCSV = eventDataCSV[2] + "-" + eventDataCSV[1] + "-" + eventDataCSV[0];
      console.log('end date', this.endDateIsoCSV)
    },
    /*download master data */

    exportCSV() {
      this.exportName = this.selectedTab === 'Driver' ? 'driver' : 'vehicle'


      axios({
        method: 'get',
        url: `${Config.serverURI}/export/${this.exportName}/compliance?startDate=${this.startDateIsoCSV}&endDate=${this.endDateIsoCSV}`,
        responseType: 'arraybuffer'
      })
        .then((response) => {
          this.exportName = ''
          console.log("response of download", response)
          const arrayBuffer = response.data
          const filename = 'Locations.xlsx';
          this.downloadFileFromArrayBuffer(arrayBuffer, filename);
        }).catch((err) => {
          console.log("err", err)
        })

    },
    /*download file */
    downloadFileFromArrayBuffer(arrayBuffer, filename) {
      const url = URL.createObjectURL(new Blob([arrayBuffer], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',

      }))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', filename)
      document.body.appendChild(link)
      link.click()
    },
    clearStatusGA() {
      this.parameterss = '';
      delete this.parameters.region;
      delete this.params.region;
      // delete this.parameters['region'];
      this.regionValue = 'all';
      this.$refs.vehilceTable.refresh();
      this.$refs.driverTable.refresh();
    },
    fiteredResultGA(e) {
      if (e.target.value === 'all') {
        this.parameterss = ''
        this.regionValue = 'all';
        delete this.parameters.region;
        delete this.params.region;
      } else {
        this.parameterss = e.target.value;
      }
      this.$refs.vehilceTable.refresh();
      this.$refs.driverTable.refresh();
    },
    getGeographicalAreas() {
      this.loading = true;
      const params = {};
      params.$limit = 0;
      let journeyManagerList = [];

      this.$regionsDataRepository.list(params)
        .then(res => {
          this.loading = false;
          if (res.data.docs) {
            if (this.user.roleName === 'Admin') {
              journeyManagerList = res.data.docs.map(item => {
                return {
                  key: item._id,
                  value: item.name,
                };
              });
              this.journey_managers = journeyManagerList;
            } else {
              journeyManagerList = res.data.docs.map(item => {
                if (this.regionManagersIdList.includes(item._id)) {
                  this.journey_managers.push({
                    key: item._id,
                    value: item.name,
                  });
                }
              });
            }
          }
        })
        .catch(error => {
          this.loading = false;
          console.error('journey Manager.requestFunction-error:', error);
          this.$snotify.error('Get journey manager list failed', 'Error!');
        });
    },



    dateFormatters(query) {
      // return dateFormatter(query.createdAt);
      return moment(query).format("DD-MM-YYYY");
    },

    getDateClass(expiryDate) {

      if (!expiryDate) {
        return 'na';
      }

      const today = new Date();
      const expiry = new Date(expiryDate);

      const daysRemaining = Math.floor((expiry - today) / (24 * 60 * 60 * 1000));

      if (daysRemaining < 0) {
        return 'expired';
      } else if (daysRemaining <= 90) {
        return 'expires-soon';
      } else {
        return 'valid';
      }
    },

    clearFilter() {
      if (this.selectedTab === 'Driver') {
        this.date.startDate = '';
        this.date.endDate = '';
        delete this.params.startDate;
        delete this.params.endDate;
        this.$refs.driverTable.refresh();
      }

      if (this.selectedTab === 'Vehicle') {
        this.date.startDate = '';
        this.date.endDate = '';
        delete this.parameters.startDate;
        delete this.parameters.endDate;
        this.$refs.vehilceTable.refresh();
      }

    },
    startDate() {
      const eventData = this.date.startDate.split("-");
      this.startDateIso = eventData[2] + "-" + eventData[1] + "-" + eventData[0];
    },
    endDate() {
      if (this.date.startDate != "" && this.date.endDate != "") {
        const eventData = this.date.endDate.split("-");
        const endDate = eventData[2] + "-" + eventData[1] + "-" + eventData[0];
        if (this.selectedTab === 'Driver') {
          this.params.endDate = endDate;
          this.params.startDate = this.startDateIso;
          this.$refs.driverTable.refresh();
        }
        if (this.selectedTab === 'Vehicle') {
          this.parameters.endDate = endDate;
          this.parameters.startDate = this.startDateIso;
          this.$refs.vehilceTable.refresh();
        }
      }
    },
    showDriver() {
      if (this.date.startDate || this.date.endDate) {
        this.date.startDate = '';
        this.date.endDate = '';
        delete this.params.startDate;
        delete this.params.endDate;
      }
      this.selectedTab = 'Driver';
      this.showDriverTable = true;
      this.showVehicleTable = false;
      this.clearFilterCSV();
    },
    showVehicle() {
      if (this.date.startDate || this.date.endDate) {
        this.date.startDate = '';
        this.date.endDate = '';
        delete this.params.startDate;
        delete this.params.endDate;
      }
      this.selectedTab = 'Vehicle';
      this.showVehicleTable = true;
      this.showDriverTable = false;
      this.clearFilterCSV();
    },
    onLoaded() {
      this.driverTable = this.$refs.driverTable;
    },
    onLoad() {
      this.vehilceTable = this.$refs.vehilceTable;
    },
  },
  created() {
    this.driverActive = 'active';
    let regionDetails = this.$store.state.auth.userRegion.regionDetails
    if (regionDetails && regionDetails.length !== 0) {
      this.regionManagersIdList = regionDetails.map(item => item._id);

    }
  },
}
</script>
<style>
.filter_wrpp button svg {
  width: 20px;
  height: 20px;
  margin-right: 10px;
}

.filter_wrpp button {
  display: flex;
  align-items: center;
  margin-right: 5px;
}

.filter_wrpp button:hover {
  background: rgba(38, 153, 251);
  color: #fff;
}

.filter {
  margin-top: 10px;
}

.filtered {
  margin-left: 73%;
}

.main_select_wrp_relative .modal-dialog {
  display: flex;
  justify-content: center;
  width: 67% !important;
}

.main_select_wrp_relative {
  position: absolute;
  right: 30%;
  top: 25px;
}

.main_select_wrp_relative+.add-item {
  display: flex;
}

.clearButton {
  margin-right: 33px;
  opacity: 0.8;
  color: blue;
  text-decoration: underline;
  font-size: large;
}

.modal-header {
  padding-bottom: 0px;
  padding-top: 0px;
}

.modal-header .close {
  margin-top: -31px;
  padding-right: 18px;
}

.table-responsive,
.VuePagination,
.form-group.form-inline.pull-left.VueTables__search,
.form-group.form-inline.pull-right.VueTables__limit {
  font-weight: normal !important;
}

h2 {
  font-size: 20px;
}

.modal-content {
  width: 55%;
}

.applyFilter {
  position: absolute;
  top: 61px;
  right: 157px;
  z-index: 100;
}

.tab-pane.fade.in {
  margin-top: 10px;
}

.na {
  color: gray;
  font-weight: 800;
  /* or any other color you prefer for "NA" */
}

.expired {
  color: red;
  font-weight: 800;
}

.expires-soon {
  color: orange;
  font-weight: 800;
}

.valid {
  color: green;
  font-weight: 800;
}

.sorting2 {
  position: absolute;
  left: 80px;
  z-index: 1000;
  /* width: 225px; */
  margin-left: 250px;
  top: 62px;
}
</style>



// WEBPACK FOOTER //
// complianceReport.vue?e9737104